import type { ApolloClient } from '@apollo/client';

import { RefreshTokenDocument } from '@/features/Auth/_graphql/mutation/RefreshToken.hook';

export const callRefreshTokenMutation = async (
	client: ApolloClient<unknown>,
	username: string | null
) => {
	if (!username) {
		return Promise.reject(new Error('Username is required'));
	}
	return client.mutate({
		mutation: RefreshTokenDocument,
		variables: { username }
	});
};
